import { AxiosError } from 'axios'
import { createContext } from 'react'

export const AppContext = createContext<{ toggleColorMode: () => void; error: AxiosError | Error | null }>({
  toggleColorMode: () => {},
  error: null,
})

export default AppContext
